import { Alert, AlertTitle, Box, Button, Snackbar, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useCreateRehabProjectMutation, useGetRehabProjectsQuery } from "../gql/generated/queries";
import { useAuth } from "../auth";
import { useAppSelector } from "../redux/store";
import { selectOrder } from "../redux/slices/reportSlice/report";
import useReportId from "../utils/report/useReportId";
import { captureException } from "../vendor/sentry";
import { LocalStorageKey } from "../vendor/local";

export const RehabRedirectButton = React.memo(() => {
  const reportId = useReportId();
  const { userContext: { currentContractor } } = useAuth();
  const { teamId, property } = useAppSelector(selectOrder);
  const teamUser = useMemo(() => (currentContractor?.teamUsers || []).find((t) => t.team?.id === teamId), [currentContractor]);
  const isPartOfTeam = Boolean(teamUser);
  const allowRehabToolAccess = Boolean(teamUser?.team?.allowRehabToolAccess);

  const { data, isLoading, refetch } = useGetRehabProjectsQuery({ reportId }, { skip: !reportId || !isPartOfTeam });
  const [createRehabProject, { error, isLoading: createRehabLoading }] = useCreateRehabProjectMutation();

  const projectId = useMemo(() => data?.rehabProjects?.edges?.find((edge) => edge?.node?.teamId === teamId)?.node?.id, [data, teamId]);

  const handleClick = async () => {
    try {
      const userId = localStorage.getItem(LocalStorageKey.SelectedContractor);
      if (!projectId) {
        const response = await createRehabProject({
          input: {
            name: `${property?.address || ''} ${Date.now().toString()}`,
            address: property?.address || '',
            teamId: teamId || '',
            reportId,
          }
        });
        await refetch();
        // await getRehabProject({ reportId });
        const projectId = response?.data?.createRehabProject?.project?.id;
        window.location.assign(`${process.env.REACT_APP_MARKETPLACE_FRONTEND_URL}/rehab/${projectId}?behaveAs=${userId}`);
      } else {
        window.location.assign(`${process.env.REACT_APP_MARKETPLACE_FRONTEND_URL}/rehab/${projectId}?behaveAs=${userId}`);
      }
    } catch (e) {
      captureException(e, { source: 'RehabRedirectButton', action: 'createRehabProject' });
    }
  }

  if (!reportId || !isPartOfTeam || !allowRehabToolAccess || !property) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleClick}
        disabled={!reportId || !isPartOfTeam || !allowRehabToolAccess}
        loading={isLoading || createRehabLoading}
      >
        {!projectId ? "Start " : "Continue "}rehab project
      </Button>
      <Snackbar
        key="permits-pdf-download-snackbar"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={!!error}
      >
        <Alert severity="error">
          <AlertTitle>Could not create the Rehab project</AlertTitle>
          <Box>
            <Typography>Something went wrong.</Typography>
            <Typography>{error?.message}</Typography>
          </Box>
        </Alert>
      </Snackbar>
    </>
  );
});
